/**
 * On-prem license activation (ADR-0073 slice 1c/1d).
 * Backend router: backend/src/hub/admin/routes/license.py (paths relative to /api/admin).
 * On the SaaS / dev these routes are inert (not enforced, no license server).
 */
import { api } from "./api";

export interface LicenseStatus {
  enforced: boolean;
  server_configured: boolean;
  activated: boolean;
  /** active | grace | expired | invalid | none */
  state: string;
  organization: string | null;
  expires_at: string | null;
  heartbeat_at: string | null;
  installation_id: string | null;
}

export const licenseApi = {
  status: () => api.get<LicenseStatus>("/license"),
  activate: (activationKey: string) =>
    api.post<LicenseStatus>("/license/activate", { activation_key: activationKey }),
  heartbeat: () => api.post<LicenseStatus>("/license/heartbeat"),
};
